import React, { useState } from 'react';

import styles from './Agreement.module.scss';
import ContainerPage from '../../UI/ContainerPage/ContainerPage';
import Button from '../../UI/Button/Button';
import Alert from '../../UI/Alert/Alert';

type AgreementProps = {
  title: string;
  description: string;
  checkboxLabel: string;
  buttonLabel: string;
  alreadyAcceptedLabel: string;
  globalState: any;
};

function Agreement({
  title,
  description,
  checkboxLabel,
  buttonLabel,
  alreadyAcceptedLabel,
  globalState,
}: AgreementProps) {
  const { onPageCompleted, getCurrentPage, getTracking, goNextPage } =
    globalState;
  const currentPage = getCurrentPage();
  const pageTracking = getTracking(currentPage.resourceId);
  const pageCompleted = pageTracking?.completed;
  const [agreed, setAgreed] = useState<boolean>(false);

  function handleConfirm() {
    onPageCompleted(() => goNextPage());
  }

  return (
    <ContainerPage
      className={styles.Agreement}
      title={title}
      globalState={globalState}
    >
      <div className={styles.Agreement__intro}>
        <p>{description}</p>
      </div>
      <hr />
      {!pageCompleted && (
        <div className={styles.Agreement__checkbox}>
          <input
            type="checkbox"
            name="agreed"
            id="agreed"
            onChange={(e) => setAgreed(e.target.checked)}
            disabled={pageCompleted}
          />
          <label htmlFor="agreed">{checkboxLabel}</label>
        </div>
      )}
      <div className={styles.Agreement__footer}>
        {!pageCompleted ? (
          <Button
            primary
            onClick={handleConfirm}
            globalState={globalState}
            disabled={!agreed}
          >
            {buttonLabel}
          </Button>
        ) : (
          <Alert success>{alreadyAcceptedLabel}</Alert>
        )}
      </div>
    </ContainerPage>
  );
}

export default Agreement;
